export type Testimonial = {
  quote: string
  author: string
  role: string
  avatar?: string
}

export type CoachProfile = {
  name: string
  role: string
  bio: string
}

/**
 * Keep these EMPTY until you have real reviews from real buyers (with their
 * permission). The review sections only render when these arrays have items.
 */
export const coachProfiles: CoachProfile[] = []
export const shortTestimonials: Testimonial[] = []
export const moreTestimonials: Testimonial[] = []

/**
 * Real words from rec gymnastics coaches on a public coaching forum (ChalkBucket).
 * They describe the problem, they are NOT reviews of this product.
 */
export type ForumQuote = { quote: string; context: string }

export const forumQuotes: ForumQuote[] = [
  {
    quote:
      '…somehow every week turns into a free-for-all and you can’t tell that I spent about 5 hours planning our class at all.',
    context: 'Rec coach · coaching forum, 2024',
  },
  {
    quote:
      'If I take the time to correct anything or work with a student for even a moment, all control is lost.',
    context: 'Rec coach · coaching forum, 2024',
  },
  {
    quote: 'the rec program’s are getting a little bit old…Even the head coach is running out of ideas',
    context: 'Gym coach · coaching forum, 2014',
  },
]
